import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrendingNeutralIcon(props: IconProps) {
    return <Icon {...props} iconKey={"trending_neutral"}/>
}
